import type { TokenError } from '../schema/TokenError';
import type { AuthTokenResponse } from '../schema/AuthTokenResponse';
import type { TokenResponseExtended as TokenResponse } from 'owa-service/lib/tokenResponseExtended';

/**
 * Returns an response of type AuthTokenResponse that has the access token issued
 * and a suberrorcode if token fetching failed due to AdalException. Some of the
 * possible values are: interaction_required, login_required etc. (these are an indication
 * that AAD did not issue a token to OWA until user/ partner teams remediate it)
 */
export function getAuthTokenResponse(tokenResponse?: TokenResponse): AuthTokenResponse {
    const authTokenError: TokenError = {
        // SubErrorCode carries the MSAL AuthError.errorCode surfaced by the MsalAcquireToken event.
        subErrorCode: tokenResponse?.SubErrorCode,
        // SubError carries the MSAL AuthError.subError surfaced by the MsalAcquireToken event.
        subError: tokenResponse?.SubError,
    };

    const authTokenResponse: AuthTokenResponse = {
        error: authTokenError,
        accessToken: tokenResponse?.AccessToken,
        accessTokenExpiry: tokenResponse?.AccessTokenExpiry,
        expiresIn: tokenResponse?.ExpiresIn,
        additionalData: tokenResponse?.AdditionalData,
    };

    return authTokenResponse;
}
